(function($) {

    var siteHeader = document.getElementById('siteHeader');
    var siteMain = document.getElementById('siteMain');
    var siteHeaderHeight = $(siteHeader).outerHeight();

    $(siteHeader).addClass('is-fixed');
    $(siteMain).css('padding-top', siteHeaderHeight + 'px');

}(jQuery));



// WEBPACK FOOTER //
// ./js/src/app/sticky-nav.js